var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"blogPostContent",staticClass:"post-content -mt-24 bg-white w-full relative flex flex-col h-full text-gray-700 phone:py-12 py-24",class:{'drop-cap': _vm.dropCap},domProps:{"innerHTML":_vm._s(_vm.blogPostContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }